module.exports = '<svg width="27" height="32" viewBox="0 0 27 32"><path d="M10.668 1.328v21.294l-6.454-6.244a1.392 1.392 0 0 0-1.907 0L.395 18.2a1.253 1.253 0 0 0 0 1.824l12.018 11.602a1.404 1.404 0 0 0 1.912 0l11.949-11.527a1.243 1.243 0 0 0 0-1.824l-1.91-1.824a1.395 1.395 0 0 0-1.91 0l-6.452 6.244V1.329c0-.739-.595-1.328-1.334-1.328h-2.667a1.33 1.33 0 0 0-1.334 1.328z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-4.js
// module id = 1107
// module chunks = 14